const Footer = () => (
    <footer className="footer">
        <p>The best deals - aggregated from all over the internet</p>
    </footer>
);

export default Footer;